import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { getEmptyLocation } from 'src/app/interfaces/location';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { LocationService } from 'src/app/services/location.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';
// import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent implements OnInit {
  location: any;

  companyId: any;
  company: any;
  token: any;

  constructor(
    private locationService: LocationService,
    private toastS: ToastService,
    private cs: CompanyService,
    private storage: Storage,
    private auth: AuthService
  ) {
    this.locationService.locationDataSubject.subscribe(x => {
      this.location = getEmptyLocation();
      this.location = x;
      console.log('getThisLocation', this.location);
    }, err => {
      console.log('getThisLocationERROR', err);
    });
  }

  async ngOnInit() {
    console.log("LOCATION: ", this.location)
  }

  async ionViewWillEnter() {
  }

  save() {
    this.locationService.saveLocation(this.location).subscribe(x => {
      this.locationService.locationSave.next(x);
      this.toastS.addToast();
    });
  }

  getData(event) {
    console.log(event)

  }

  async companyAdress() {
    this.token = await this.auth.getDecodedUserToken();

    this.cs.getCompanyById(this.token.company).subscribe(x => {
      this.company = x;
      console.log(this.company, 'COMPANY');
      this.location.street = this.company.street;
      this.location.zipcode = this.company.zipcode;
      this.location.city = this.company.town;
      this.location.building_number = this.company.number;
    })
    // this.cs.getCompanyById(this.company.company).subscribe(x => {

    // })
  }
}
